import React from "react";
import PropTypes from "prop-types";

import Icon from "../Icon";
import styles from "./KeepReading.css";

export default function KeepReading(props) {
  var block = props.block,
      extras = props.extras;
  var data = block.data;

  var _ref = extras || {},
      wordCount = _ref.wordCount;

  return React.createElement(
    "button",
    { id: "keep-reading-" + block.key, className: styles.root, "aria-expanded": false },
    React.createElement(Icon, { name: "chevron/down", description: "Read more toggle", className: styles.icon }),
    React.createElement(
      "div",
      { className: styles.showLess },
      "Show less"
    ),
    React.createElement(
      "div",
      { className: styles.keepReading },
      data.buttonText,
      data.showWordCount && wordCount && React.createElement(
        "span",
        { className: styles.wordCount },
        wordCount,
        " Words"
      )
    ),
    React.createElement(
      "div",
      { className: styles.hide },
      props.children
    )
  );
}

KeepReading.propTypes = {
  block: PropTypes.object.isRequired,
  extras: PropTypes.object
};


// WEBPACK FOOTER //
// ./src/components/Library/KeepReading/KeepReading.js